
import { supabase } from '@/integrations/supabase/client';

// Находит ID курьера по различным идентификаторам пользователя
export async function findCourierId(user: any): Promise<string | null> {
  if (!user) return null;
  
  // Попытка найти курьера по ID пользователя
  const { data: courierDataById, error: courierErrorById } = await supabase
    .from('couriers')
    .select('id')
    .eq('id', user.id)
    .single();
  
  if (courierDataById && !courierErrorById) {
    console.log('Найден курьер по ID пользователя:', courierDataById);
    return courierDataById.id;
  }
  
  // Попытка найти курьера по email
  if (user.email) {
    const { data: courierDataByEmail, error: courierErrorByEmail } = await supabase
      .from('couriers')
      .select('id')
      .eq('email', user.email)
      .single();
      
    if (courierDataByEmail && !courierErrorByEmail) {
      console.log('Найден курьер по email:', courierDataByEmail);
      return courierDataByEmail.id;
    }
  }
  
  // Попытка найти курьера по телефону
  if (user.phone) {
    console.log('Поиск курьера по телефону:', user.phone);
    
    const normalizedPhone = user.phone.startsWith('+') ? user.phone : '+' + user.phone;
    const phoneWithoutPlus = normalizedPhone.startsWith('+') ? normalizedPhone.substring(1) : normalizedPhone;
    
    const { data: courierDataByPhone, error: courierErrorByPhone } = await supabase
      .from('couriers')
      .select('id')
      .or(`phone.eq.${normalizedPhone},phone.eq.${phoneWithoutPlus}`)
      .single();
    
    if (courierDataByPhone && !courierErrorByPhone) {
      console.log('Найден курьер по телефону:', courierDataByPhone);
      return courierDataByPhone.id;
    }
  }
  
  // Тестовый аккаунт
  if (user.email === 'courier@example.com') {
    const testCourierId = '6ab29258-5ca8-43b2-992a-88a0ea513e0c';
    console.log("Используем тестовый ID для courier@example.com:", testCourierId);
    return testCourierId;
  }
  
  return null;
}

// Создает тестовые данные для демонстрации
export function createMockRentals() {
  const mockRentals = [
    {
      id: 'mock-1',
      bike_id: 'bike-1',
      bikes: { model: 'Тестовый велосипед 1' },
      start_date: '2025-03-01',
      end_date: '2025-03-15',
      status: 'completed',
      amount: 8000,
      human_number: 'AR-00123',
      documents_url: 'https://example.com/documents'
    },
    {
      id: 'mock-2',
      bike_id: 'bike-2',
      bikes: { model: 'Тестовый велосипед 2' },
      start_date: '2025-03-20',
      end_date: '2025-04-20',
      status: 'active',
      amount: 14000,
      human_number: 'AR-00124',
      documents_url: 'https://example.com/documents'
    },
    {
      id: 'mock-3',
      bike_id: 'bike-3',
      bikes: { model: 'Тестовый велосипед 3' },
      start_date: '2025-04-25',
      end_date: null,
      status: 'pending',
      amount: 6000,
      human_number: 'AR-00125',
      documents_url: null
    }
  ];
  
  return mockRentals;
}
